import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import Picture from '../../atoms/Picture'
import FormikForm from '../../form/FormikForm'
import FormFieldToggleButtonGroup from '../../form/fields/FormFieldToggleButtonGroup'
import Html from '../../atoms/Html'

export const Main = styled.section`
  border-radius: 2rem;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  &:not(:first-child) {
    margin-top: 4rem;
  }
`

export const BackgroundImage = styled(Picture)`
  width: 100%;
  & img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`

export const Card = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.aliceBlue};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Bezel = styled.svg`
  position: absolute;
  top: -0.9rem;
  width: 100%;
  height: 1rem;
  & path {
    fill: ${({ theme }) => theme.colors.aliceBlue};
  }
`

export const Content = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.5rem 3rem 1.5rem;

  @media ${mq(sizes.tablet)} {
    padding: 0 2rem 3rem 2rem;
  }
`
export const Pastille = styled.div`
  ${({ theme }) => theme.textStyles.titleH3};
  position: absolute;
  top: -3.5rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  color: ${({ theme }) => theme.colors.ruby};
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.pattensBlue};
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH1};
    top: -6rem;
    width: 8rem;
    height: 8rem;
  }
`

export const NumberOfQuestion = styled.p`
  margin-top: 3rem;
  text-align: center;
  ${({ theme }) => theme.textStyles.titleH7}
  color: ${({ theme }) => theme.colors.ruby};
`

export const Title = styled(Html)`
  ${({ theme }) => theme.textStyles.titleH4};
  margin: 0;
  color: ${({ theme }) => theme.colors.arapawa};
  text-align: center;
  width: 100%;
  padding: 1.5rem 2rem;
  &:last-child {
    padding-bottom: 2rem;
  }

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH3};
  }
`

export const AnswerTitle = styled.h3`
  ${({ theme }) => theme.textStyles.titleH4};
  margin: 0;
  color: ${({ theme }) => theme.colors.ruby};
  text-align: center;
  width: 100%;
  margin: 4rem 0 0 0;
  text-align: center;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH3};
  }
`

export const Text = styled(Html)`
  ${({ theme }) => theme.textStyles.textSmall};
  color: ${({ theme }) => theme.colors.arapawa};
  margin: 1.5rem 0 4rem 0;
  text-align: center;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.textMedium};
  }
`

export const Form = styled(FormikForm)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // to all div because i'm tired
  & div {
    justify-content: center;
  }
`

export const Button = styled(FormFieldToggleButtonGroup)`
  width: 100%;

  & div {
    display: flex;
    flex-direction: column;
  }

  @media ${mq(sizes.tablet)} {
    width: initial;

    & div {
      flex-direction: row;
    }
  }
`

export const ActionButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media ${mq(sizes.tablet)} {
    flex-direction: row;
    gap: 3rem;
    width: initial;
  }
`
